import { api } from '@/lib/api.js';

// Producer picker search, shared by every door that names a producer (the
// submission doors, the roster sheet). /api/tracon/producers returns Contacts of
// type Producer only, because the CRM Producer lookup rejects anything else.
// Rows come back CRM-shaped for CrmContactPicker.
export function searchProducers(q) {
  return api.get(`/api/tracon/producers?q=${encodeURIComponent(q)}`)
    .then((r) => (r?.producers || []).map((p) => ({ id: p.id, Full_Name: p.name, Account_Name: p.account })));
}
